import { render, staticRenderFns } from "./history_tbale.vue?vue&type=template&id=265ea850&scoped=true&"
import script from "./history_tbale.vue?vue&type=script&lang=js&"
export * from "./history_tbale.vue?vue&type=script&lang=js&"
import style0 from "./history_tbale.vue?vue&type=style&index=0&id=265ea850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265ea850",
  null
  
)

export default component.exports